angular.module('impactx.swimLane').controller('SwimLaneCtrl', [
    '$scope',
    '$redirect',
    'searchFilter',
    'TranslationService',
    'panelService',
    SwimLaneCtrl]);

function SwimLaneCtrl($scope, $redirect, searchFilter, TranslationService, panelService) {
    $scope.getSupplierPanelColor = panelService.getSupplierPanelColor;
    $scope.goToSearchList = function() {
        if ($scope.continueSearch) {
            searchFilter.clearSearchInput();
        }
        $redirect.redirectTo(null, $scope.morelink);
    };
    if(searchFilter.searchInput.length > 0) {
        $scope.searchListLabel = TranslationService.get('continueSearch').replace('^0', searchFilter.searchInput);
    }
}